import {
  fetchAll,
  fetchFiltered,
  fetchByClient,
  fetchAllContracts,
  add,
  edit,
  show,
  activeContract,
  inactiveContract,
  blockContract,
  unblockContract,
} from "@/api/contracts";

const state = {
  all: [],
  isLoading: false,
  contractById: {},
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchAll({ dispatch, commit }) {
    try {
      const contracts = await fetchAll();
      commit("setAll", contracts);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchFiltered({ dispatch, commit }, params) {
    try {
      const contracts = await fetchFiltered(params);
      commit("setAll", contracts);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchByClient({ dispatch, commit }, client) {
    try {
      const contracts = await fetchByClient(client);
      commit("setAll", contracts);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchAllContracts({ dispatch, commit }, payload) {
    try {
      const contracts = await fetchAllContracts(payload);
      commit("setAll", contracts);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async edit({ dispatch, commit }, { id, data }) {
    try {
      commit("setLoading", true);
      dispatch(
        "overlay/show",
        { isShow: true, message: "Editando contrato ..." },
        { root: true }
      );

      await edit(id, data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
      dispatch("overlay/show", false, { root: true });
    }
  },

  async create({ dispatch, commit }, data) {
    try {
      commit("setLoading", true);
      dispatch(
        "overlay/show",
        { isShow: true, message: "Criando contrato ..." },
        { root: true }
      );

      await add(data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
      dispatch("overlay/show", false, { root: true });
    }
  },

  async fetchById({ dispatch, commit }, id) {
    try {
      dispatch(
        "overlay/show",
        {
          isShow: true,
          message: "Carregando contrato ...",
        },
        { root: true }
      );
      const contract = await show(id);
      commit("setContractById", contract);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },

  async activeContract({ dispatch, commit }, id) {
    try {
      commit("setLoading", true);
      await activeContract(id);
      return true;
    } catch (error) {
      dispatch("notify/error", error, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async inactiveContract({ dispatch, commit }, id) {
    try {
      commit("setLoading", true);
      await inactiveContract(id);
      return true;
    } catch (error) {
      dispatch("notify/error", error, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async unblockContract({ dispatch, commit }, { id, data }) {
    try {
      commit("setLoading", true);
      await unblockContract(id, data);
      return true;
    } catch (error) {
      dispatch("notify/error", error, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async blockContract({ dispatch, commit }, id) {
    try {
      commit("setLoading", true);
      await blockContract(id);
      return true;
    } catch (error) {
      dispatch("notify/error", error, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
    }
  },
};

const mutations = {
  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.contractById = {};
  },

  setAll(state, contracts) {
    state.all = contracts;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  setContractById(state, contract) {
    state.contractById = contract;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
